import { loadServerTranslations } from "../../i18n/messages";
import Account from "pages/[lang]/account";
import { Locales } from "i18n/country";

export default Account;

export const getServerSideProps = async () => {
  const locale = Locales.USA;

  return {
    props: {
      locale,
      messages: await loadServerTranslations(locale, ["common", "page-account-dashboard", "page-account-reports"]),
    },
  };
};
